import { render, staticRenderFns } from "./social-buttons.vue?vue&type=template&id=41b351fb&scoped=true"
import script from "./social-buttons.vue?vue&type=script&lang=js"
export * from "./social-buttons.vue?vue&type=script&lang=js"
import style0 from "./social-buttons.vue?vue&type=style&index=0&id=41b351fb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41b351fb",
  null
  
)

export default component.exports